module.exports = __webpack_public_path__ + "static/media/waiting-room-bg.32d05d16.svg";